import { ReferralTemplate } from "modules/ClientAccount/components/ReferralLinkWidget/ReferralTemplate"

export function ReferralB2c() {
    return (
        <ReferralTemplate
            title={<>Получите 4&nbsp;сессии со&nbsp;скидкой&nbsp;10%</>}
            details={
                <>
                    Отправьте другу скидку на&nbsp;терапию и&nbsp;сэкономьте&nbsp;10%
                    на&nbsp;следующие 4&nbsp;сессии.
                </>
            }
        />
    )
}
